export const avSettingKeys = {
    OPEN_AV_SETTINGS: 'OPEN_AV_SETTINGS',
}
